<template>
	<div>
		<div :style="cssPropsFooter" class="mt-5 img_footer"></div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			cssPropsFooter: {
				backgroundImage: `url(${require("@/assets/bgg.png")})`,
				height: "15vh",
				backgroundRepeat: "no-repeat",
				backgroundSize: "cover",
			}
		}
	},
}
</script>

<style lang="scss" scoped>
@media (max-width: 390px) {

	.img_footer {
		margin-top: 10px !important;
	}
}
</style>
